export default {
    // 全局方法
    install(Vue, options) {
         // 切换在线客服，封装公共方法
        Vue.prototype.$gotoCSInPage = function(data) {
            if(localStorage.getItem('isOwnerCS') == 1){
                let userId = localStorage.getItem('userId');
                let memberName = localStorage.getItem("memberName")
                let headUrl = localStorage.getItem("headUrl") || ''
                let key = Object.keys(data);
                let pageName = data[key[0]]
                if(userId){
                    window.open('http://customer-service-workbench.zczy.com/#/chat?pageName=' + pageName + '&channelFlag=15&userId=' + userId + '&userName=' + memberName + '&userPic' + headUrl)
                }
            }else {
                zc('config', { customer_fields: JSON.stringify(data) }); // 配置参数，取值参考原型附件表格前面的序号
                zc('dynamic_ready'); // a标签是后加的，动态初始化
            }
        }
    }
}
  